module.exports = __webpack_public_path__ + "img/got.88946f57.png";